import { DEFAULT_COOKIE_EXPIRY_DAYS, BID_PREFIX } from '../utils/consts.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Creates the global settings object, to be used by the library
 * @param settingsInput - Global settings added by the developer.
 * @returns an ISettings with the settings added by the developer
 */
function createSettings(settingsInput) {
    validateSettings(settingsInput);
    const { clientKey, targetURL, cookieDomain, cookiePath, cookieExpiryDays, forceServerCookieMode, includeUTMParameters, pointOfSale, } = settingsInput;
    return {
        clientKey: clientKey,
        cookieSettings: {
            cookieDomain,
            cookieExpiryDays: cookieExpiryDays || DEFAULT_COOKIE_EXPIRY_DAYS,
            cookieName: `${BID_PREFIX}${clientKey}`,
            cookiePath: cookiePath || '/',
            forceServerCookieMode: forceServerCookieMode !== null && forceServerCookieMode !== void 0 ? forceServerCookieMode : false,
        },
        includeUTMParameters: includeUTMParameters !== null && includeUTMParameters !== void 0 ? includeUTMParameters : true,
        pointOfSale: pointOfSale !== null && pointOfSale !== void 0 ? pointOfSale : undefined,
        targetURL: targetURL,
    };
}
/**
 * A validation function for the required global settings
 */
function validateSettings(settings) {
    const { clientKey, targetURL, pointOfSale } = settings;
    if (!clientKey)
        throw new Error(`[MV-0001] "clientKey" is required.`);
    if (!targetURL)
        throw new Error(`[MV-0002] "targetURL" is required.`);
    if (pointOfSale && pointOfSale.trim().length === 0)
        throw new Error('[MV-0009] "pointOfSale" cannot be empty.');
    try {
        new URL(targetURL);
    }
    catch (e) {
        throw new Error(`[IV-0001] Incorrect value for "targetURL". Set the value to a valid URL string.`);
    }
}
/**
 * A function that updates Point of sale in init settings object and in the Window.Engage object
 */
function updatePointOfSale(pointOfSale, settings) {
    if (pointOfSale && pointOfSale.trim().length > 0) {
        if (window && window['Engage'] && window['Engage'].settings) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            window['Engage'].settings.pointOfSale = pointOfSale;
        }
        settings.pointOfSale = pointOfSale;
    }
    else {
        throw new Error('[MV-0009] "pointOfSale" cannot be empty.');
    }
}

export { createSettings, updatePointOfSale, validateSettings };
